import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DashValidation } from 'dash-common';
import {
  Box,
  Text,
  ViewerContext,
  Button,
  Spinner,
  Flex,
  TooltipWrapper,
  useScreenResolution,
} from 'dash-ui';

import { useGetCurrentStripeAccountQuery } from 'gql/generated.graphql';

import {
  DeletePaymentMethodModal,
  EmptyPaymentMethodsContainer,
} from './components';
import { PaymentMethodsSectionContainer } from './PaymentMethodsSection.styles';
import PaymentMethodCardItem from './components/PaymentMethodCardItem/PaymentMethodCardItem';
import AddPaymentMethodModal from './components/AddPaymentMethodModal/AddPaymentMethodModal';

function PaymentMethodsSection() {
  const theme = useTheme();
  const { t } = useTranslation(['pages']);
  const { t: billingPageLabels } = useTranslation('pages', {
    keyPrefix: 'profilePage.billing',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { account } = useContext(ViewerContext);
  const { data, refetch, loading } = useGetCurrentStripeAccountQuery();
  const { paymentMethods } = data?.getCurrentStripeAccount || {};
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const isButtonDisabled =
    (paymentMethods?.length || 0) >=
    DashValidation.MaxCustomerCardPaymentMethods;

  useEffect(() => {
    refetch();
  }, [account]);

  return (
    <PaymentMethodsSectionContainer flex={1} flexDirection="column" mt={1}>
      <Text bold lg={!isMobile}>
        {billingPageLabels('paymentMethod')}
      </Text>
      <Box w="100%">
        {loading && (
          <Flex alignItems="center" justifyContent="center" py={4}>
            <Spinner color={theme.colors.b100} />
          </Flex>
        )}
        {paymentMethods ? (
          paymentMethods.map((paymentMethod) => (
            <PaymentMethodCardItem
              key={paymentMethod.paymentMethodId}
              paymentMethod={paymentMethod}
              defaultPaymentMethodId={account?.stripeDefaultPaymentMethodId}
            />
          ))
        ) : (
          <EmptyPaymentMethodsContainer />
        )}
        <TooltipWrapper
          w="100%"
          content={
            isButtonDisabled
              ? <Box w="100%">t('pages:brokersPage.toast.maxPaymentMethod')</Box>
              : ''
          }
        >
          <Button
            mt={3}
            minHeight={56}
            w="100%"
            icon="creditCard"
            variation="outline"
            disabled={isButtonDisabled}
            onClick={() => setIsModalOpen(true)}
          >
            {billingPageLabels('addPaymentMethod')}
          </Button>
        </TooltipWrapper>
        <AddPaymentMethodModal
          isOpened={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
        <DeletePaymentMethodModal />
      </Box>
    </PaymentMethodsSectionContainer>
  );
}

export default PaymentMethodsSection;
